import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = [
  <path
    key="1"
    d="M13.3768 5.57736C11.0563 7.69688 11.1785 10.5922 11.1785 11.5342C11.1785 11.5342 15.3988 12.4208 17.9364 10.135C20.5012 7.86311 20.1348 4.1782 20.1348 4.1782C20.1348 4.1782 15.9009 3.26389 13.3768 5.57736Z"
  />,
  <path key="2" d="M10.0442 4.18311H5.07751V20.1557H10.0442V4.18311Z" />,
  <path
    key="3"
    d="M17.928 14.2227C15.404 11.9508 11.1701 12.8374 11.1701 12.8374C11.1701 13.7517 11.048 16.6608 13.3684 18.7942C15.8925 21.0661 20.1264 20.1656 20.1264 20.1656C20.1264 20.1656 20.4928 16.4807 17.928 14.2227Z"
  />,
];

const smallIcon = [
  <path
    key="1"
    d="M8.91789 3.7182C7.3709 5.13121 7.45232 7.06141 7.45232 7.68941C7.45232 7.68941 10.2659 8.28048 11.9576 6.75664C13.6674 5.24204 13.4232 2.78542 13.4232 2.78542C13.4232 2.78542 10.6006 2.17589 8.91789 3.7182Z"
  />,
  <path key="2" d="M6.69612 2.7887H3.38501V13.4371H6.69612V2.7887Z" />,
  <path
    key="3"
    d="M11.952 9.48174C10.2693 7.96713 7.44672 8.5582 7.44672 8.5582C7.44672 9.16773 7.3653 11.1072 8.9123 12.5294C10.595 14.044 13.4176 13.4437 13.4176 13.4437C13.4176 13.4437 13.6618 10.9871 11.952 9.48174Z"
  />,
];

export const LogoTSKIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="LogoTSK" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
